import styled from '@emotion/styled'
import DynamicInput from '../DynamicInput'

export const StyledDynamicInput = styled(DynamicInput)`
  margin-top: 10px;
`

export const StyledInputsWrapper = styled.div`
  > div {
    margin-top: 10px;
  }
`
